import type { FunctionComponent } from 'react';
import React, { useCallback, useState } from 'react';
import { SingleBoardViewProvider } from 'app/src/components/BoardViewContext/SingleBoardViewProvider';
import { SingleBoardViewFiltersProvider } from 'app/src/components/ViewFilters/SingleBoardViewFiltersProvider';
import type { FilterPopoverButtonProps } from './FilterPopoverButton';
import { FilterPopoverButton } from './FilterPopoverButton';

interface Props extends Omit<FilterPopoverButtonProps, 'PopoverWrapper'> {
  idBoard: string;
  isDateBasedView: boolean;
}

export const SingleBoardViewFilterPopoverButtonContainer: FunctionComponent<Props> = ({
  idBoard,
  isDateBasedView,
  ...rest
}) => {
  const [skip, setSkip] = useState(true);
  const loadData = useCallback(() => skip && setSkip(false), [skip, setSkip]);

  return (
    <SingleBoardViewFiltersProvider idBoard={idBoard}>
      <SingleBoardViewProvider
        idBoard={idBoard}
        isDateBasedView={isDateBasedView}
        skip={skip}
      >
        <FilterPopoverButton {...rest} onLoad={loadData} />
      </SingleBoardViewProvider>
    </SingleBoardViewFiltersProvider>
  );
};
